import { api } from "@/builders/axios";

const get = function (variables: {
  id: number;
  data: {
    name: string;
    bio: string;
    description: string;
    thumbnail_id: number;
    organization_id: number;
  };
}) {
  return api
    .post(`instructors/${variables.id}`, variables.data)
    .then(({ data }) => data);
};

const fetch_metrics = function (id: number) {
  return api.get(`instructors/${id}/fetch-metrics`).then(({ data }) => data);
};

const del = function (id: number) {
  return api.get(`instructors/${id}`).then(({ data }) => data);
};

const put = function (id: number) {
  return api.put(`instructors/${id}`).then(({ data }) => data);
};

export const id = {
  get,
  fetch_metrics,
  del,
  put,
};

